/**
 * File: utils.ts
 * Description: Utility functions for the application
 * Author: System
 * Created: 2025-09-03
 * Last Modified: 2025-09-03
 */

import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
